

import {
    Customer,
    DomainGroupMembersEntity,
    DomainUsersEntity,
    EmailNotifications,
    PrivacyPolicy,
    Settings,
    SocialMedia,
    UserInterface,
} from '@monsido/modules/models/api/interfaces/user.interface';
import { LanguageType } from '@monsido/angular-shared-components';


export class User implements UserInterface {
    constructor (user: Partial<UserInterface>) {
        this.id = typeof user.id === 'number' ? user.id : 0;
        this.email = typeof user.email === 'string' ? user.email : '';
        this.first_name = typeof user.first_name === 'string' ? user.first_name : '';
        this.last_name = typeof user.last_name === 'string' ? user.last_name : '';
        if (user.locale !== undefined) {
            this.locale = user.locale;
        }
        if (user.timezone !== undefined) {
            this.timezone = user.timezone;
        }
        if (user.contact_info !== undefined) {
            this.contact_info = user.contact_info;
        }
        if (user.social_media !== undefined) {
            this.social_media = user.social_media;
        }
        if (user.title !== undefined) {
            this.title = user.title;
        }
        if (user.description !== undefined) {
            this.description = user.description;
        }
        if (user.phone !== undefined) {
            this.phone = user.phone;
        }
        if (user.otp !== undefined) {
            this.otp = user.otp;
        }
        if (user.created_at !== undefined) {
            this.created_at = user.created_at;
        }
        if (user.updated_at !== undefined) {
            this.updated_at = user.updated_at;
        }
        if (user.last_login_at !== undefined) {
            this.last_login_at = user.last_login_at;
        }
        if (user.customer_admin !== undefined) {
            this.customer_admin = user.customer_admin;
        }
        if (user.customer !== undefined) {
            this.customer = user.customer;
        }
        if (user.domain_users !== undefined) {
            this.domain_users = user.domain_users;
        }
        if (user.domain_group_members !== undefined) {
            this.domain_group_members = user.domain_group_members;
        }
        if (user.settings !== undefined) {
            this.settings = user.settings;
        }
        if (user.email_notifications !== undefined) {
            this.email_notifications = user.email_notifications;
        }
        if (user.association_level !== undefined) {
            this.association_level = user.association_level;
        }
        if (user.api_key !== undefined) {
            this.api_key = user.api_key;
        }
        if (user.intercom_user_hash !== undefined) {
            this.intercom_user_hash = user.intercom_user_hash;
        }
        if (user.privacy_policy !== undefined) {
            this.privacy_policy = user.privacy_policy;
        }
        if (user.user !== undefined) {
            this.user = user.user;
        }
        if (user.labels !== undefined) {
            this.labels = user.labels;
        }
    }

    id: number;
    email: string;
    first_name: string;
    last_name: string;
    preview_customer?: boolean;
    locale?: LanguageType;
    timezone?: string;
    contact_info?: null;
    social_media?: SocialMedia;
    title?: null;
    description?: null;
    phone?: null;
    otp?: boolean;
    created_at?: string;
    updated_at?: string;
    last_login_at?: string;
    customer_admin?: boolean;
    customer?: Customer;
    domain_users?: DomainUsersEntity[];
    domain_group_members?: DomainGroupMembersEntity[];
    settings?: Settings;
    email_notifications?: EmailNotifications;
    association_level?: number;
    api_key?: string;
    intercom_user_hash?: string;
    privacy_policy?: PrivacyPolicy;
    user?: {
        id?: number;
        email?: string;
        first_name?: string;
        last_name?: string;
    };
    labels?: {
        id: number,
        name: string,
        color: string,
        created_at: string,
        updated_at: string
    }[];

    getAvatarInitials (): string {
        return `${this.getFirstName()
            .charAt(0)
            .toUpperCase()}${this.getLastName()
            .charAt(0)
            .toUpperCase()}`;
    }

    getName (): string {
        return `${this.getFirstName()} ${this.getLastName()}`;
    }

    getFirstName (): string {
        return (typeof this.first_name === 'string' ? this.first_name : '').trim();
    }
    getLastName (): string {
        return (typeof this.last_name === 'string' ? this.last_name : '').trim();
    }
}
